<template>
	<v-app>
		<template v-if="$route.name !== 'login'">
			<navbar @update-drawer="drawer = !drawer"/>
			<navigation-drawer v-model="drawer"/>
		</template>

		<div class="primary">
			<v-main
				class="white ps-0"
				:class="
					$route.name !== 'login'
						? {
							'rounded-r-large': $vuetify.rtl && $vuetify.breakpoint.mdAndUp,
							'rounded-l-large': !$vuetify.rtl && $vuetify.breakpoint.mdAndUp,
						}
						: null
				"
				:style="
					'min-height: 100vh;' + (
						$route.name !== 'login' && $vuetify.breakpoint.mdAndUp
							? `margin-${$vuetify.rtl ? 'right' : 'left'}: ${drawer ? 215 :  56}px;`
							: ''
					)
				"
			>
				<v-container
					fluid
					class="px-7 py-2"
					:style="{ minHeight: `${$vuetify.breakpoint.height - 82}px` }"
				>
					<div
						v-if="!Object.keys(companyInfo).length && !['login', 'home'].includes($route.name)"
						class="d-flex justify-center align-center"
						:style="{ height: `${$vuetify.breakpoint.height - 130}px` }"
					>
						<v-progress-circular size="45" indeterminate color="primary" />
					</div>
					<router-view v-else/>
				</v-container>
				<p v-if="$route.name !== 'login'" class="powered-by">
					powered by
					<a
						target="_blank"
						href="https://www.beetronix.com"
						class="text-decoration-none"
					>
						BEETRONIX
					</a>
				</p>
			</v-main>
		</div>

		<v-snackbar
            v-model="snackbar"
            :color="getSnackbarColor()"
        >
            {{ message }}
            <template v-slot:action="{ attrs }">
				<v-btn
					color="white"
					icon
					v-bind="attrs"
					@click="snackbar = false"
				>
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
	</v-app>
</template>

<script>
import Navbar from './components/Navbar.vue';
import NavigationDrawer from './components/NavigationDrawer.vue';
import { mapState } from 'vuex';
import { userMultiCenter } from './configs/general.configs';

export default {
	name: 'App',

	components: {
		Navbar,
		NavigationDrawer
	},

	data: () => ({
		drawer: false,
		snackbar: false,
		msgState: null,
		message: null
	}),

	watch: {
		snackbar(newVal) {
			if (!newVal) {
				this.message = null;
			}
		}
	},

	computed: {
		...mapState({
			authenticated: state => state.auth.authenticated,
			companyInfo: state => state.companyInfo.companyInfo,
		}),
	},

	methods: {
		getSnackbarColor() {
			switch (this.msgState) {
			case 'error': return 'red lighten-1';
			case 'warning': return 'primary lighten-1';
			case 'info': return 'green';
			}
		}
	},

	created() {
		this.$eventBus.$on('show-snackbar', (state, message) => {
			this.msgState = state;
			this.message = message;
			this.snackbar = true;
		});

		if (
			!this.authenticated &&
			this.$route.query.userName &&
			this.$route.query.password &&
			this.$route.query.centerId
		) {
			this.$store.dispatch('auth/login', {
				username: this.$route.query.userName,
				password: this.$route.query.password,
				centerId: userMultiCenter ? this.$route.query.centerId : 0,
				isMD5: true
			}).then(() => {
				this.$store.dispatch('companyInfo/fetchAll');
				if (this.$route.name === 'login') {
					this.$router.push({ name: 'home' });
				}
			});
		}
	},

	metaInfo() {
		return {
			title: 'Edunix transport',
			titleTemplate: `Edunix transport - ${this.$t(`routes.${this.$route.name}`)}`
		}
	}
};
</script>

<style lang="scss">
@import '@/scss/main.scss';

#app {
	* {
		font-family: 'Fairuz', sans-serif !important;
	}
	.rounded-tr-large {
		border-top-right-radius: 30px;
	}
	.rounded-r-large {
		border-top-right-radius: 30px;
		border-bottom-right-radius: 30px;
	}
	.rounded-tl-large {
		border-top-left-radius: 30px;
	}
	.rounded-l-large {
		border-top-left-radius: 30px;
		border-bottom-left-radius: 30px;
	}

	.powered-by {
		text-align: center;
		margin: 0;
		font-size: 11px;
		line-height: 22px;
	}

	.v-snack__wrapper {
		border-radius: 11px;
	}
	.v-btn:not(.v-btn--fab, .v-btn--icon), .v-list {
		border-radius: 10px;	
	}
	.v-item-group {
		border-radius: 12px;	
	}
	.v-menu__content {
		border-radius: 10px;	
	}
	.v-data-table, .v-data-table__wrapper, .v-data-table-header, .v-map__wrapper {
		border-radius: 15px;
	}
	// .v-list-item {
	// 	border-radius: 8px;
	// 	overflow: hidden;
	// }
	.v-treeview-node {
		border-radius: 5px;
		overflow-y: hidden;
	}
	.v-input {
		border-radius: 12px;
		*:not(.v-icon) {
			font-size: 14px;
		}
	}

	.v-data-footer__select {
		height: 40px;
	}

	.v-map__wrapper {
		border: 1px solid #0f4d96;
	}

	.v-dialog, .v-card {
		border-radius: 11px;
	}

	.v-picker--full-width .v-time-picker-clock__container {
		max-width: 200px;
		max-height: 200px;
	}
	.v-picker__title {
		padding: 7px 16px;

		.v-time-picker-title {
			justify-content: center;
		}
	}
}
*::-webkit-scrollbar{
    height: 5px;
    width: 5px;
	background-color: #f8f8f8;
}
*::-webkit-scrollbar-thumb{
    background-color: #888;
    border-radius: 10px;
}
</style>
